import {
    ADD_ACTIVITY_TO_COMPARE_LIST,
    REMOVE_ACTIVITY_FROM_COMPARE_LIST,
    CLEAR__COMPARE_LIST,
    LOGIN_USER,
    LOGIN_AS_CUSTOMER,
    LOGOUT_USER
} from '../actions/actions';

const initialState = [];

const compareActivities = (state = initialState, action) => {
    if (action.type === ADD_ACTIVITY_TO_COMPARE_LIST) {
        return [...state, action.activity];
    }
    if (action.type === REMOVE_ACTIVITY_FROM_COMPARE_LIST) {
        return state.filter(e => e.id !== action.activityId);
    }
    // actions that trigger a compare clear
    if ([CLEAR__COMPARE_LIST, LOGIN_USER, LOGIN_AS_CUSTOMER, LOGOUT_USER].includes(action.type)) {
        return [];
    }
    return state;
};

export default compareActivities;
